import React, { useState } from "react";
import "./css/app.css";
import "./js/slotmachine";
import BG from "../../assets/images/econnect-ai-driven-16.jpg";
import logo from "../../assets/images/Logo_250.png";
import { Col, Row, Image, Button, Space } from "antd";
import { Idashboard } from "../check-in-manule/common";
import axios from "axios";

// var $ = require("jquery");

export const PlayLuckyDraw: React.FC = (): React.ReactElement => {
  const [data, setData] = useState<Idashboard[]>([]);
  const apilocal = `http://localhost:4000`;
  const apiprod = `${window.location.origin}/public/api`;

  const updateStatus = async () => {
    const res = await axios.put(`${apiprod}/api/user/luckstatus/1`);
    setData(res.data);
  };

  return (
    <div className="w-full border-none bg-cover bg-no-repeat bg-right p-5 h-full">
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Image src={logo} preview={false} width={150} />
        </Col>
        <Col span={24} className="w-full pt-[150px]">
          <div className="panel">
            <div
              className="panel-body"
              style={{ backgroundImage: `url(${BG})` }}
            >
              <div id="lbl-example4"></div>
              <div id="data-selected"></div>
              <div className="text-center">
                <Space>
                  <Button
                    onClick={() => updateStatus()}
                    type="primary"
                    className="rounded-[10px]"
                  >
                    START
                  </Button>
                </Space>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
